import { colors } from '../styles/theme';
import { useLocation } from 'react-router-dom';

const ROUTE_LABELS = {
  '/dashboard': 'Pano',
  '/satinalma': 'Satınalma',
  '/stok-depo': 'Stok & Depo',
  '/uretim': 'Üretim',
  '/recete-maliyet': 'Reçete & Maliyet',
  '/finans': 'Finans',
  '/raporlar-grup': 'Raporlar',
  '/tedarikciler-grup': 'Tedarikçiler',
  '/entegrasyon': 'Entegrasyon',
  '/yonetim': 'Yönetim',
  '/satis-analiz': 'Satış & Analiz',
};

const Header = ({ title }) => {
  const location = useLocation();
  const routeLabel = ROUTE_LABELS[location.pathname];
  const breadcrumb = (routeLabel && routeLabel !== title) ? routeLabel : null;

  return (
    <div data-page-header="true" style={{
      background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
      color: 'white',
      padding: '12px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
    }}>
      {/* Subtle pattern overlay */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.04,
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 20px, rgba(255,255,255,1) 20px, rgba(255,255,255,1) 21px)',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        {breadcrumb && (
          <div style={{
            fontSize: '11px', opacity: 0.6, marginBottom: '2px',
            fontWeight: 500, letterSpacing: '0.02em',
          }}>
            Pano &rsaquo; {breadcrumb}
          </div>
        )}
        <h1 style={{
          margin: 0, fontSize: '17px', fontWeight: 600,
          letterSpacing: '-0.01em',
        }}>{title}</h1>
      </div>
      <div style={{
        position: 'relative', zIndex: 1,
        display: 'flex', alignItems: 'center', gap: '15px', marginRight: '50px',
      }}>
        <span style={{
          fontSize: '12px', opacity: 0.7, fontWeight: 500,
          background: 'rgba(255,255,255,0.1)',
          padding: '4px 10px', borderRadius: '4px',
        }}>
          {new Date().toLocaleDateString('tr-TR', { weekday: 'short', day: 'numeric', month: 'short' })}
        </span>
      </div>
    </div>
  );
};

export default Header;
